import { DetailItem } from "@/components/elements/DetailItem";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { InputDateTimePicker } from "@/components/elements/InputDateTimePicker";
import { DATE_TIME_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { ProductLogoUpload } from "@/features/master-data/components/Product/ProductLogoUpload";
import { TMasterDataProductForm } from "@/features/master-data/types/masterDataProductForm";
import { dayjs } from "@/utils/dayjs";
import { Grid } from "@mui/material";
import { Control } from "react-hook-form";

type TProductFormFieldsProps = {
  control: Control<TMasterDataProductForm>;
  createdAt?: string;
  updatedAt?: string;
};

export const ProductFormFields = ({ control, createdAt, updatedAt }: TProductFormFieldsProps) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <FormField control={control} name="name">
          <Input placeholder="例：visa" />
        </FormField>
      </Grid>
      <Grid item xs={12}>
        <FormField control={control} name="logo">
          <ProductLogoUpload />
        </FormField>
      </Grid>
      <Grid item xs={12}>
        <FormField control={control} name="introductionPageUrl">
          <Input />
        </FormField>
      </Grid>
      <Grid item xs={12}>
        <FormField control={control} name="apiEndpoint">
          <Input />
        </FormField>
      </Grid>
      <Grid item xs={6}>
        <FormField control={control} name="singleCharLabel">
          <Input />
        </FormField>
      </Grid>
      <Grid item xs={6}>
        <FormField control={control} name="publishedAt">
          <InputDateTimePicker />
        </FormField>
      </Grid>
      {createdAt !== undefined && (
        <Grid item xs={6}>
          <DetailItem label="登録日" value={createdAt ? dayjs(createdAt).format(DATE_TIME_FORMAT) : EMPTY_STR.DATE_TIME} />
        </Grid>
      )}
      {updatedAt !== undefined && (
        <Grid item xs={6}>
          <DetailItem label="更新日" value={updatedAt ? dayjs(updatedAt).format(DATE_TIME_FORMAT) : EMPTY_STR.DATE_TIME} />
        </Grid>
      )}
    </Grid>
  );
};
